import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  protected readonly appCode = "ROB";
  isGuidedFlow: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    // WebLogger.init() is now called in main.ts before Angular bootstraps
    // to ensure it's available for web-vitals callbacks and early logging

    // Note: Baggage initialization moved to APP_INITIALIZER in app.module.ts
    // to ensure it runs before any HTTP requests are made

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isGuidedFlow = event.urlAfterRedirects.includes("guided-flow");
      }
    });
  }

}
